import { EVENT_TYPES } from 'src/api/getEvents/types';
import type { IExternalSystem } from 'src/helpers/channels/channelToAvatar';
import type { IExcludedScheduleItem, ScheduleEventType } from 'src/api/getSchedules/types';
import { ChannelAvatarTooltip } from 'src/components/ChannelAvatarTooltip';

interface IPublishCardItem {
  event_type: ScheduleEventType;
  entity_name?: string | null;
  price_scheme: { name: string } | null;
  venues: { venue_id: string; name: string }[];
  external_systems: IExternalSystem[];
  excluded_items?: IExcludedScheduleItem[];
}

const ENTITY_LABELS: Partial<Record<ScheduleEventType, string>> = {
  [EVENT_TYPES.PUBLISH_TIMETABLE]: 'Timetable',
  [EVENT_TYPES.PUBLISH_MENU_SET]: 'Menu Set',
};

export const getPublishCardDetails = (schedule: IPublishCardItem, menuName?: string) => {
  const menuLabel = schedule.entity_name ?? menuName;
  const entityLabelText = ENTITY_LABELS[schedule.event_type] ?? 'Menu';
  const menuDetail = menuLabel ? { text: entityLabelText, detail: menuLabel } : null;
  const venuesDetail = { text: 'Venues', detail: String(schedule.venues.length) };
  const channelsDetail = {
    text: 'Channels',
    detail: <ChannelAvatarTooltip externalSystems={schedule.external_systems} />,
  };

  const excludedProducts = schedule.excluded_items
    ? [{ text: 'Excluded Products', detail: String(schedule.excluded_items.length) }]
    : [];

  if (schedule.event_type === EVENT_TYPES.PUBLISH_PRODUCT) {
    return [...(menuDetail ? [menuDetail] : []), ...excludedProducts, channelsDetail];
  }

  if (schedule.event_type === EVENT_TYPES.PUBLISH_PRICING) {
    return [
      ...(menuDetail ? [menuDetail] : []),
      ...(schedule.price_scheme ? [{ text: 'Pricing', detail: schedule.price_scheme.name }] : []),
      ...excludedProducts,
      channelsDetail,
      venuesDetail,
    ];
  }

  return [
    ...(menuDetail ? [menuDetail] : []),
    ...(schedule.price_scheme ? [{ text: 'Pricing', detail: schedule.price_scheme.name }] : []),
    channelsDetail,
    venuesDetail,
  ];
};
